import React from 'react';
import styled from 'styled-components';
import { formatCurrency } from 'js/services/Format';
import { greenColor } from 'js/config/style';
import MiniText from 'js/components/core/MiniText';
import Title from './Title';
import Subtitle from "js/components/pages/CheckoutPage/DropOffDetails/ProductDisplayV2/Subtitle";

const Container = styled.div`
  padding: 0 1rem 0;
  position: relative;
  padding-top: 10px;
  padding-bottom: 10px;
`;

const Price = styled.div`
  position: absolute;
  bottom: 0;
  font-weight: bold;
  color: ${greenColor.hex()};
`;

export default ({ title, price, country }) => (
  <Container>
    <Title>{title}</Title>
    <Subtitle style={{fontSize:'14px'}}>{formatCurrency(price, 'NGN')} per unit</Subtitle>
    {/*<Price>{formatCurrency(price)}</Price>*/}
  </Container>
);
